import getBrowserFingerprint from 'get-browser-fingerprint';

export async function generateFingerprint() {
    return await getBrowserFingerprint();
}
